// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MoveGroupsToSpaceList__list-b6c5ef {
  flex-grow: 1;
  overflow: auto;
}

.MoveGroupsToSpaceList__list-item-d70e27 {
  background-color: var(--group-list-item-background);
  align-items: center;
  cursor: pointer;
  display: flex;
  padding: 8px 16px;
  --group-list-item-background: var(--base-0);
}

.MoveGroupsToSpaceList__list-item-d70e27:hover,
.MoveGroupsToSpaceList__list-item-d70e27:focus {
  --group-list-item-background: var(--base-17);
}

.MoveGroupsToSpaceList__avatar-c12f14 {
  position: relative;
  margin-inline-end: 12px;
}

.MoveGroupsToSpaceList__space-avatar-bb0d6a {
  background-color: var(--group-list-item-background);
  border-radius: 8px;
  padding: 2px;
  position: absolute;
  right: -4px;
  bottom: -4px;
}

.MoveGroupsToSpaceList__info-e5c50f {
  flex: 1;
  padding-inline-end: 12px;
  overflow: hidden;
}

.MoveGroupsToSpaceList__name-wrapper-ae8b12 {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  overflow: hidden;
}

.MoveGroupsToSpaceList__name-a9a93b {
  color: var(--base-110);
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
}

.MoveGroupsToSpaceList__members-count-f1bb05 {
  color: var(--base-80);
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
}

.MoveGroupsToSpaceList__name-a9a93b,
.MoveGroupsToSpaceList__members-count-f1bb05 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.MoveGroupsToSpaceList__empty-f3e185 {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/MoveGroupsToSpacePopup/MoveGroupsToSpaceList/MoveGroupsToSpaceList.styles.m.css"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,cAAA;AACF;;AAEA;EACE,mDAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,iBAAA;EAEA,2CAAA;AAAF;;AAGA;;EAEE,4CAAA;AAAF;;AAGA;EACE,kBAAA;EACA,uBAAA;AAAF;;AAGA;EACE,mDAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AAAF;;AAGA;EACE,OAAA;EACA,wBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,gBAAA;AAAF;;AAGA;EACE,sBAAA;EACA,wBAAA;EACA,0CAAA;AAAF;;AAGA;EACE,qBAAA;EACA,4BAAA;EACA,8CAAA;AAAF;;AAGA;;EAEE,gBAAA;EACA,uBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,WAAA;AAAF","sourcesContent":[".list {\n  flex-grow: 1;\n  overflow: auto;\n}\n\n.list-item {\n  background-color: var(--group-list-item-background);\n  align-items: center;\n  cursor: pointer;\n  display: flex;\n  padding: 8px 16px;\n\n  --group-list-item-background: var(--base-0);\n}\n\n.list-item:hover,\n.list-item:focus {\n  --group-list-item-background: var(--base-17);\n}\n\n.avatar {\n  position: relative;\n  margin-inline-end: 12px;\n}\n\n.space-avatar {\n  background-color: var(--group-list-item-background);\n  border-radius: 8px;\n  padding: 2px;\n  position: absolute;\n  right: -4px;\n  bottom: -4px;\n}\n\n.info {\n  flex: 1;\n  padding-inline-end: 12px;\n  overflow: hidden;\n}\n\n.name-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  overflow: hidden;\n}\n\n.name {\n  color: var(--base-110);\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n}\n\n.members-count {\n  color: var(--base-80);\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n}\n\n.name,\n.members-count {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.empty {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list": `MoveGroupsToSpaceList__list-b6c5ef`,
	"list-item": `MoveGroupsToSpaceList__list-item-d70e27`,
	"listItem": `MoveGroupsToSpaceList__list-item-d70e27`,
	"avatar": `MoveGroupsToSpaceList__avatar-c12f14`,
	"space-avatar": `MoveGroupsToSpaceList__space-avatar-bb0d6a`,
	"spaceAvatar": `MoveGroupsToSpaceList__space-avatar-bb0d6a`,
	"info": `MoveGroupsToSpaceList__info-e5c50f`,
	"name-wrapper": `MoveGroupsToSpaceList__name-wrapper-ae8b12`,
	"nameWrapper": `MoveGroupsToSpaceList__name-wrapper-ae8b12`,
	"name": `MoveGroupsToSpaceList__name-a9a93b`,
	"members-count": `MoveGroupsToSpaceList__members-count-f1bb05`,
	"membersCount": `MoveGroupsToSpaceList__members-count-f1bb05`,
	"empty": `MoveGroupsToSpaceList__empty-f3e185`
};
module.exports = ___CSS_LOADER_EXPORT___;
